import React, { useState } from "react";
import { Image } from "antd";
import { LandTourDayImage } from "../../../../interfaces/land-tour.interface";

interface Props {
  images: LandTourDayImage[];
}

// 3 columns x 2 rows is the most the grid shows; the last cell carries the "N+ Photos" overlay when
// there are more. 1 and 2 images get larger tiles (Figma 10102:260275 / 12851:273039).
const MAX_VISIBLE = 6;

export default function GroundTourItineraryImages({ images }: Props) {
  const [previewVisible, setPreviewVisible] = useState(false);
  const [current, setCurrent] = useState(0);

  if (!images.length) return null;

  const visible = images.slice(0, MAX_VISIBLE);
  const layout = images.length === 1 ? "one" : images.length === 2 ? "two" : "grid";
  // Tiles use the resized copies (a single large tile needs the bigger mobile one); the viewer opens the originals.
  const tileSrc = (image: LandTourDayImage) => (layout === "one" ? image.mobile : image.thumb) || image.original;
  const hiddenCount = images.length - MAX_VISIBLE;

  const open = (index: number) => {
    setCurrent(index);
    setPreviewVisible(true);
  };

  return (
    <div className={`ground-tour-show-v2__day-images is-${layout}`}>
      {visible.map((image, index) => {
        const isLast = index === MAX_VISIBLE - 1 && hiddenCount > 0;

        return (
          <button
            type="button"
            className="ground-tour-show-v2__day-image"
            key={index}
            onClick={() => open(index)}
            aria-label={isLast ? `View all ${images.length} photos` : "View photo"}
          >
            <img src={tileSrc(image)} alt="" loading="lazy" />
            {isLast && <span className="ground-tour-show-v2__day-image-more">{hiddenCount + 1}+ Photos</span>}
          </button>
        );
      })}

      <div style={{ display: "none" }}>
        <Image.PreviewGroup
          items={images.map((image) => image.original)}
          preview={{
            rootClassName: "ground-tour-day-image-preview",
            visible: previewVisible,
            current,
            onVisibleChange: (v) => setPreviewVisible(v),
            onChange: (c) => setCurrent(c),
          }}
        />
      </div>
    </div>
  );
}
